import { FEATURES, PERMISSION_NOT_ALLOWED } from '/src/features/_global/constants';
import { SHARABLE_RESOURCE_TYPES } from '../team-and-sharing/constants';

export const FUNNELS_PERMISSIONS = {
  [FEATURES.FUNNELS]: ({ capabilities, isSharing, sharedResource }) => {
    const sharedResourceIsFunnel = sharedResource?.resource?.resourceType === SHARABLE_RESOURCE_TYPES.FUNNEL;
    return isSharing
      ? {
          navigate: PERMISSION_NOT_ALLOWED,
          view: sharedResourceIsFunnel ? { allowed: true } : PERMISSION_NOT_ALLOWED,
          edit: PERMISSION_NOT_ALLOWED,
        }
      : {
          navigate: capabilities?.funnels.permissions.nav,
          view: capabilities?.funnels.permissions.view,
          edit: capabilities?.funnels.permissions.edit,
        };
  },
};
